import Vue from "vue";

/**
 * H5 首页滚动与菜单高亮同步。
 * index.vue 在 hash 锚点滚动结束后会 replace 掉 hash，故不能仅靠 $route.hash 判断当前区块。
 */

/** 与 mobile/index.vue 内各 section 的 id 一致，须自上而下排序（用于滚动判定） */
export const MOBILE_HOME_NAV_SECTION_IDS = [
  "section-top",
  "section-news",
  "section-about",
  "section-dj",
];

export const mobileHomeActiveSectionState = Vue.observable({
  /** 当前视口认定的首页区块 id */
  anchorId: "section-top",
});

/**
 * 按视口顶部偏移判定「当前」区块（经过某 section 顶边即视为进入该区块）
 * @param {number} [offsetPx] 视口顶部向下偏移，略大于固定导航占位
 */
export function setMobileHomeActiveSectionByScroll(offsetPx = 72) {
  if (typeof document === "undefined") return;
  let current = MOBILE_HOME_NAV_SECTION_IDS[0];
  for (const id of MOBILE_HOME_NAV_SECTION_IDS) {
    const el = document.getElementById(id);
    if (!el) continue;
    const top = el.getBoundingClientRect().top;
    if (top <= offsetPx) {
      current = id;
    }
  }
  mobileHomeActiveSectionState.anchorId = current;
}

export function setMobileHomeActiveSectionAnchorIdImmediate(id) {
  if (MOBILE_HOME_NAV_SECTION_IDS.includes(id)) {
    mobileHomeActiveSectionState.anchorId = id;
  }
}

export function resetMobileHomeActiveSectionAnchor() {
  mobileHomeActiveSectionState.anchorId = "section-top";
}
